import React from 'react';
import { toast, ToastOptions } from 'react-toastify';

import { Appear } from '@src/components/ui/Snackbar/Snackbar.styles';
import { Content } from '@src/components/ui/Snackbar/Snackbar';

export type SnackFunction = (
  message: string | React.ReactNode,
  action?: {
    label: string;
    onClick: () => void;
  } | null,
  options?: ToastOptions
) => void;

const snack: SnackFunction = (message, action, options = {}) =>
  toast.info(<Content message={message} action={action} />, {
    ...options,
    transition: Appear,
    theme: 'colored',
    hideProgressBar: true,
    position: toast.POSITION.BOTTOM_CENTER,
    icon: false,
    containerId: 'snackbar-container',
  });

export default snack;
